import $ from "jquery";
import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import { Popup, Button } from 'semantic-ui-react'

import Title from '../../title';
import Loading from '../../loading';
import Server from '../../../functions/server';
import ReadCookie from '../../../functions/readcookies';
import Permission from '../../../functions/permission';
import getFormatedDate from '../../../functions/date';

class Notification extends React.Component {

  state = {
    menuPermission: [], notification: [], notificationReport: [],
    fromDate: getFormatedDate(new Date(), 'fromDate'),
    toDate: getFormatedDate(new Date(), 'toDate'),
  }

  componentDidMount() {
    this.menuPermission();
  }

  menuPermission() {
    let menuPermission = Permission('notification', this.props.menus);
    if (menuPermission.view) {
      this.getNotification();
    }
    this.setState({ menuPermission })
  }

  handleChange = name => event => { this.setState({ [name]: event.target.value }); }

  getNotification() {
    let context = this;
    let { fromDate, toDate } = this.state;
    context.setState({ load: true, message: 'Getting Roles', })
    $.ajax({
      type: 'POST', data: { fromDate, toDate }, url: Server() + 'AdminControl/Notification/get.php',
      success: function (data) {
        try {
          data = JSON.parse(data);
          context.setState({ notification: data, load: false })
        } catch (e) {
          alert('Error!!!');
          context.setState({ load: false, });
        }
      },
      error: function (e) {
        alert('Try again1!!')
        context.setState({ load: false });
      }
    });
  }

  getNotificationReport(status, notification_id) {
    let context = this;
    context.setState({ load: true, message: 'Getting Notification Report', })
    $.ajax({
      type: 'POST', data: { status, notification_id }, 
      url: Server() + 'AdminControl/Notification/report.php',
      success: function (data) {
        try {
          data = JSON.parse(data);
          context.setState({ notificationReport: data, load: false, dialog: true })
        } catch (e) {
          alert('Error!!!');
          context.setState({ load: false, });
        }
      },
      error: function (e) {
        alert('Try again1!!')
        context.setState({ load: false });
      }
    });
  }

  render() {
    let { menuPermission, notification, notificationReport } = this.state;
    const { fullScreen } = this.props;
    let i = 1; let ii = 1;
    return (
      <div>
        <Title title={'Notification'} openDrawer={this.props.openDrawer} />
        <div style={{margin: '1%'}}>
          { menuPermission.view ? 
            (
              <div>
                <div style={{display: 'flex'}}>
                  <div style={{marginLeft: 5}}>
                    From Date<br/>
                    <input  onChange={this.handleChange('fromDate')} type="date"
                      value={this.state.fromDate} style={{ height: 35 }}/>
                  </div>
                  <div style={{marginLeft: 5}}>
                    To Date<br/>
                    <input  onChange={this.handleChange('toDate')} type="date"
                      value={this.state.toDate} style={{ height: 35 }} />
                  </div>
                  <div>
                    <br/>
                    <Button onClick={this.getNotification.bind(this)}>SUBMIT</Button>
                  </div>
                </div>
                <table id="table" width="100%">
                  <tr id="th">
                    <th>Sino</th>
                    <th style={{width: '7%'}}>Notification Id</th>
                    <th style={{width: '45%'}}>Title</th>
                    <th style={{width: '8%'}}>Success</th>
                    <th style={{width: '8%'}}>Fail</th>
                    <th style={{width: '20%'}}>Exective Name</th>
                    <th>{'Date & Time'}</th>
                  </tr>
                  { 
                    notification.map((c) => {
                      return (
                        <tr>
                          <td><center>{i++}</center></td>
                          <td><center>{c.id}</center></td>
                          <Popup content={c.description} trigger={<td>{c.title}</td>}  />
                          <td style={{cursor: 'pointer'}} onClick={this.getNotificationReport.bind(this, 1, c.id)}><center style={{color: '#269CB6'}}><u>{c.success}</u></center></td>
                          <td style={{cursor: 'pointer'}} onClick={this.getNotificationReport.bind(this, 0, c.id)}><center style={{color: '#269CB6'}}><u>{c.fail}</u></center></td>
                          <td>{c.name}</td>
                          <td>{c.timestamp}</td>
                        </tr>
                      )
                    })
                  }
                </table>
              </div>
            ):
            <center style={{color: 'red'}}>You Are Not Allow To Access This Menu!!!!</center>
          }
          <Dialog fullScreen={fullScreen} onClose={ () => { this.setState({ dialog: false }) }} 
            open={this.state.dialog}
            aria-labelledby="responsive-dialog-title">
            <DialogTitle id="responsive-dialog-title" style={{width: 400}}> {"Notification Report"} </DialogTitle>
            <DialogContent>
                <table width="100%" id="table">
                  <tr id="th">
                    <th>Sino</th>
                    <th>Customer Id</th>
                    <th>Customer Name</th>
                    <th>Last Log</th>
                  </tr>
                  {
                    notificationReport.map((v) => {
                      return (
                        <tr>
                          <td>{ii++}</td>
                          <td>{v.customer_id}</td>
                          <td>{v.name}</td>
                          <td>{v.lastused}</td>
                        </tr>
                      )
                    })
                  }
                </table>
            </DialogContent>
            <DialogActions>
              <Button onClick={ () => { this.setState({ dialog: false }) }} >Close</Button>
            </DialogActions>
          </Dialog>
        </div>
      </div>
    );
  }
}

export default Notification;
